document.addEventListener('DOMContentLoaded', function() {
    countdownClock.init('.tag-countdown');
    document.getElementById('form_marketingPreferences_smsMarketingAccepted').checked = true;
});
